import { HeroCardSlider } from "@hapinest/theme";
import { Box, Container } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { useAnalytics } from "../../../store/providers/AnalyticsProvider";
import { useBreakpoints } from "../../../hooks";
import * as Sentry from "@sentry/react";

const OffersSlider = ({ data, slug }) => {
    const { eventNames, sendEcommerceEvent } = useAnalytics();
    const { isExtraSmallScreen } = useBreakpoints();
    const [alreadyVisibleCards, setAlreadyVisibleCards] = useState([]);
    if (!data?.offers || !data?.offers?.length) {
        return "";
    }

    const handleVisibleSliderCards = useCallback((cards) => {
        let visibleCards = cards;
        if (isExtraSmallScreen()) {
            visibleCards = [cards];
        }
        
        const nonVisibleCards = visibleCards.filter((card) => alreadyVisibleCards.findIndex((alreadyVisibleCard) => alreadyVisibleCard.id === card.id) === -1);
        if (!nonVisibleCards.length) {
            return;
        }

        setAlreadyVisibleCards([...alreadyVisibleCards, ...nonVisibleCards]);

        const payload = {
            items: [...nonVisibleCards.map((card) => {
                return {
                    promotion_id: card.id,
                    promotion_name: card.name,
                    creative_slot: `${slug}_${card.position + 1}`,
                    creative_name: card.title
                };
            })]
        };
        sendEcommerceEvent(eventNames.VIEW_PROMOTION, payload)
            .catch(err => {
                console.error(err.message);
                Sentry.captureException(err);
            });
    }, [alreadyVisibleCards, slug]);

    const handleButtonClick = useCallback((card) => {
        const payload = {
            items: [{
                promotion_id: card.id,
                promotion_name: card.name,
                creative_slot: `${slug}_${card.position + 1}`,
                creative_name: card.title
            }]
        };
        sendEcommerceEvent(eventNames.SELECT_PROMOTION, payload)
            .then(() => {
                window.open(card.ctaLink, card.ctaLinkTarget);
            })
            .catch(err => {
                console.error(err.message);
                Sentry.captureException(err);
            });
    }, [slug]);

    return (
        <Box 
            bgcolor={data.bgColor} 
            py={10}
        >
            <Container>
                <HeroCardSlider
                    title={data.title}
                    subtitle={data.subtitle}
                    cards={data.offers}
                    titleTextColor={data.titleTextColor}
                    subtitleTextColor={data.subtitleTextColor}
                    onVisibleSliderCards={handleVisibleSliderCards}
                    onButtonClick={handleButtonClick}
                />
            </Container>
        </Box>
    );
};

OffersSlider.propTypes = {
    data: PropTypes.object,
    slug: PropTypes.string
};

export default OffersSlider;